import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'

import Form from '../elements/Form'
import TextInput from '../elements/forms/TextInput'
import GenericSelect from '../elements/forms/GenericSelect'
import Dismissible from '../elements/Dismissible'
import AppConstants from '../../utils/AppConstants'
import AppUtils from '../../utils/AppUtils'

const ERROR = {
  EMPTY_TASK: 'Veuillez spécifier la tâche à réaliser.',
  EMPTY_CONTACT: 'Veuillez sélectionner un contact d\'entretien'
}

class ControlTaskForm extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      input: this.getInitialInput(props),
      formErrors: []
    }

    // Bind events
    this.onChangeInputDescription = this.onChangeInputDescription.bind(this)
    this.onChangeInputContactType = this.onChangeInputContactType.bind(this)
    this.onChangeInputContactName = this.onChangeInputContactName.bind(this)
    this.onSubmit = this.onSubmit.bind(this)

    // Register submit event
    if (_.isFunction(this.props.registerSubmit)) {
      this.props.registerSubmit(this.onSubmit)
    }
  }

  getInitialInput(props = this.props) {
    return {
      description: (props.data && props.data.description) || '',
      type: (props.data && props.data.contact.type) || AppConstants.CONTACT.TYPE.SELF,
      contact: (props.data && props.data.contact.user && props.data.contact.user.id) || null
    }
  }

  setInput(input = {}) {
    this.setState((prevState, props) => ({
      input: _.extend(
        {},
        prevState.input,
        input
      )
    }))
  }

  componentDidUpdate(prevProps, prevState) {
    // When async fetch finished
    if (prevProps.isLoading && !this.props.isLoading) {
      this.setState({
        input: this.getInitialInput()
      })
    }
  }

  onChangeInputDescription(description) {
    this.setInput({ description })
  }

  onChangeInputContactType(type) {
    this.setInput(_.extend(
      { type },
      type === AppConstants.CONTACT.TYPE.SPECIFIC
        ? {}
        : {
            contact: null
          }
    ))
  }

  onChangeInputContactName(contact) {
    this.setInput({ contact })
  }

  onSubmit() {
    // Check that fields have been filled
    const formErrors = []
    if (!_.isString(this.state.input.description) || this.state.input.description.length === 0) {
      formErrors.push(ERROR.EMPTY_TASK)
    }
    if (this.state.input.type === AppConstants.CONTACT.TYPE.SPECIFIC && _.isNull(this.state.input.contact)) {
      formErrors.push(ERROR.EMPTY_CONTACT)
    }
    this.setState({
      formErrors
    })
    if (!_.isEmpty(formErrors)) {
      return;
    }

    // Build and submit correctly formatted input
    const input = _.extend(
      {},
      _.pick(this.state.input, 'description'),
      {
        contact: _.extend(
          _.pick(this.state.input, 'type'),
          this.state.input.type === AppConstants.CONTACT.TYPE.SPECIFIC
            ? {
                user: {
                  id: this.state.input.contact
                }
              }
            : {}
        )
      }
    )
    this.props.onSubmit(input)
  }

  render() {
    return (
      <React.Fragment>
        {
          this.props.error
            ? <Dismissible
                header={AppUtils.errorToTitle(this.props.error)}
                content={AppUtils.errorToText(this.props.error, {
                  [AppConstants.ERROR.BAD_REQUEST.UNICITY_CONSTRAINT_VIOLATION]: 'Une tâche avec la même description existe déjà.'
                })}
                color='red'
                onDismiss={this.props.onClearError}
              />
            : null
        }
        {
          !_.isEmpty(this.state.formErrors)
            ? <Dismissible
                content='Veuillez résoudre les problèmes ci-dessous avant de poursuivre.'
                color='orange'
              />
            : null
        }
        <Form
          onSubmit={this.onSubmit}
          loading={this.props.isLoading || this.props.isSaving}
        >
          <TextInput
            label='Tâche'
            placeholder='Vider les poubelles'
            value={this.state.input.description}
            onChange={this.onChangeInputDescription}
            error={
              _.contains(this.state.formErrors, ERROR.EMPTY_TASK)
                ? ERROR.EMPTY_TASK
                : null
            }
          />
          <GenericSelect
            label="Contact d'entretien"
            options={[
              {
                key: AppConstants.CONTACT.TYPE.SELF,
                value: 'Celui qui effectue le contrôle'
              },
              {
                key: AppConstants.CONTACT.TYPE.SPECIFIC,
                value: 'Une personne spécifique'
              }
            ]}
            selected={this.state.input.type}
            onChange={this.onChangeInputContactType}
          />
          {
            this.state.input.type === AppConstants.CONTACT.TYPE.SPECIFIC
              ? <GenericSelect
                  label=''
                  loading={this.props.usersIsFetching}
                  options={
                    _.isArray(this.props.usersList)
                      ? _.map(
                          this.props.usersList,
                          (user) => ({
                            key: user.id,
                            value: user.name
                          })
                        )
                      : []
                  }
                  selected={this.state.input.contact}
                  onChange={this.onChangeInputContactName}
                  error={
                    _.contains(this.state.formErrors, ERROR.EMPTY_CONTACT)
                      ? ERROR.EMPTY_CONTACT
                      : null
                  }
                  canSearch={true}
                />
              : null
          }
        </Form>
      </React.Fragment>
    )
  }
}

ControlTaskForm.propTypes = {
  data: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onClearError: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  registerSubmit: PropTypes.func,
  error: PropTypes.object,
  usersList: PropTypes.array,
  usersIsFetching: PropTypes.bool.isRequired
}

export default ControlTaskForm



// WEBPACK FOOTER //
// ./src/components/forms/ControlTaskForm.js